// extracted by mini-css-extract-plugin
export default {"aboutUsPage":"AboutUsPage_aboutUsPage__7EtsY","aboutUsContext":"AboutUsPage_aboutUsContext__kFlUq"};